import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/kfmApi";
import { Loader2, Check, BookOpen } from "lucide-react";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("loading"); // loading | done | error

  useEffect(() => {
    if (!token) {
      setState("error");
      return;
    }
    api.get(`/nuggets/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(({ data }) => setState(data.ok ? "done" : "error"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="min-h-screen bg-[#07090E] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center" data-testid="unsubscribe-page">
        <Link to="/" className="inline-flex items-center gap-2 text-[#00E5FF] mb-8">
          <BookOpen className="w-5 h-5" strokeWidth={1.5} />
          <span className="text-sm font-medium uppercase tracking-[0.2em]">OpenWord AI</span>
        </Link>

        {state === "loading" && (
          <div className="flex flex-col items-center gap-3 text-slate-500">
            <Loader2 className="w-6 h-6 animate-spin text-[#00E5FF]" strokeWidth={1.5} />
            <span className="text-sm">Updating your preferences…</span>
          </div>
        )}

        {state === "done" && (
          <div data-testid="unsubscribe-done">
            <span className="inline-flex w-12 h-12 rounded-full bg-[#10222A] text-[#00E5FF] items-center justify-center mb-4">
              <Check className="w-6 h-6" strokeWidth={2} />
            </span>
            <h1 className="text-3xl text-white">You&rsquo;ve been unsubscribed</h1>
            <p className="text-sm text-slate-400 mt-3 leading-relaxed">
              You won&rsquo;t receive any more Daily Nuggets. You&rsquo;re always welcome back — and you can still
              study the Word anytime at OpenWord AI.
            </p>
            <Link
              to="/welcome"
              className="inline-block mt-6 rounded-full bg-[#00E5FF] hover:bg-[#00B8CC] text-[#07090E] text-sm font-medium px-6 py-3 transition-colors"
            >
              Explore OpenWord AI
            </Link>
          </div>
        )}

        {state === "error" && (
          <div data-testid="unsubscribe-error">
            <h1 className="text-3xl text-white">Link not recognised</h1>
            <p className="text-sm text-slate-400 mt-3 leading-relaxed">
              This unsubscribe link is invalid or has expired. If you keep receiving emails, reply to any of
              them and we&rsquo;ll remove you right away.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
